<div class="npt-summary-tab-container">
  <!-- KPI Cards -->
  <div class="kpi-cards">
    <div class="kpi-card">
      <p class="kpi-label">Total P&amp;A Duration</p>
      <div class="kpi-value-row">
        <span class="kpi-value">{{ fmt2Decimal(isMultiWellMode ? multiWellTotalHrs : totalPaDurationHrs) }} hrs</span>
        <span class="kpi-badge">(&asymp;{{ paDurationDays }} days)</span>
      </div>
      <p class="kpi-description">Total productive + non-productive time</p>
    </div>
    <div class="kpi-card">
      <p class="kpi-label">Non Productive Time</p>
      <span class="kpi-value" style="font-weight: bold; color: black;">{{ fmt2Decimal(isMultiWellMode ? multiWellTotalNptHrs : nptTotalHrs) }} hrs</span>
      <p class="kpi-description">{{ isMultiWellMode ? '' : (nptPct + '% of total P&A time') }}</p>
      <span class="kpi-event-badge">
        {{ isMultiWellMode ? multiWellNptEvents.length : nptEvents.length }} event(s)
      </span>
    </div>
    <div class="kpi-card">
      <p class="kpi-label">NPT Cost</p>
      <span class="kpi-value" style="font-weight: bold; color: black;">{{ fmtK(isMultiWellMode ? multiWellTotalNptCost : nptCost) }}</span>
      <p class="kpi-description">{{ isMultiWellMode ? 'Total of All Selected Wells' : 'NPT-related expense' }}</p>
    </div>
  </div>

  <!-- NPT Events Table -->
  <div class="npt-events-table">
    <div class="table-header">
      <h3 class="header-title">NPT Events</h3>
      <p class="header-count">{{ isMultiWellMode ? multiWellNptEvents.length : nptEvents.length }} event(s) recorded</p>
    </div>
    <div class="table-scroll">
      <table>
        <thead>
          <tr *ngIf="isMultiWellMode">
            <th>Well</th>
            <th>Category/Detail</th>
            <th>Description</th>
            <th>Duration (hrs)</th>
            <th>Cost</th>
            <th>Service Contractor</th>
            <th>Start Date</th>
            <th>End Date</th>
          </tr>
          <tr *ngIf="!isMultiWellMode">
            <th>Category/Detail</th>
            <th>Description</th>
            <th>Duration (hrs)</th>
            <th>Cost</th>
            <th>Service Contractor</th>
            <th>Start Date</th>
            <th>End Date</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="isMultiWellMode">
            <tr *ngFor="let ev of multiWellNptEvents">
              <td class="table-cell-left" style="font-weight: bold;">{{ ev.wellName }}</td>
              <td style="font-weight: bold;">{{ (ev.majorCategory || ev.driver || '—') }} / {{ (ev.detail || '—') }}</td>
              <td class="table-cell-desc">{{ ev.description }}</td>
              <td style="font-weight: bold;">{{ fmt2Decimal(ev.duration) }}</td>
              <td style="font-weight: bold;">{{ fmtK(ev.cost) }}</td>
              <td>{{ ev.serviceContractor || '—' }}</td>
              <td>{{ ev.startDate }}</td>
              <td>{{ ev.endDate }}</td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!isMultiWellMode">
            <tr *ngFor="let ev of nptEvents">
              <td style="font-weight: bold;">{{ (ev.majorCategory || ev.driver || '—') }} / {{ (ev.detail || '—') }}</td>
              <td class="table-cell-desc">{{ ev.description }}</td>
              <td style="font-weight: bold;">{{ fmt2Decimal(ev.duration) }}</td>
              <td style="font-weight: bold;">{{ fmtK(ev.cost) }}</td>
              <td>{{ ev.serviceContractor || '—' }}</td>
              <td>{{ ev.startDate }}</td>
              <td>{{ ev.endDate }}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Causal Analysis -->
  <div class="causal-analysis">
    <div class="analysis-header">
      <div class="header-content">
        <div class="header-title">
          <h3>Causal Analysis</h3>
          <span class="ai-badge">
            <img src="assets/images/ai_sparkle.png" alt="AI" class="icon-image-natural" />
            AI Generated
          </span>
        </div>
        <p class="header-description">Root cause mapping for each NPT event</p>
      </div>
      <div style="display:flex;align-items:center;gap:8px;">
         <button (click)="toggleDailyOps.emit()" class="header-button">
          <img src="assets/images/log-file-format.png" alt="Daily Logs" class="icon-image-natural" />
          Daily Logs
        </button>
        <button (click)="toggleTimeLog.emit()" class="header-button">
          <img src="assets/images/timelog.png" alt="Time Log" class="icon-image-natural" />
          Time Log
        </button>
      </div>
    </div>
    <div class="analysis-scroll">
      <!-- Loading state with spinner -->
      <div *ngIf="apiRcaLoading" class="loading-container">
        <img src="assets/images/spinner.png" alt="Loading" class="spinner-icon" />
        <p class="loading-text">Loading causal analysis...</p>
      </div>

      <!-- Table content -->
      <table *ngIf="!apiRcaLoading">
        <thead>
          <tr *ngIf="isMultiWellMode">
            <th>Well Name</th>
            <th>NPT Event</th>
            <th>Root Cause</th>
            <th *ngIf="hasRcaAccess()">Status</th>
          </tr>
          <tr *ngIf="!isMultiWellMode">
            <th>NPT Event</th>
            <th>Root Cause</th>
            <th *ngIf="hasRcaAccess()">Status</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="isMultiWellMode">
            <tr *ngFor="let row of multiWellCausalAnalysis; let i = index">
              <td class="table-cell-desc" style="font-weight: bold;">{{ row.wellName }}</td>
              <td class="table-cell-desc" style="font-weight: bold;">{{ row.nptEvent }}</td>
              <td class="table-cell-desc" style="font-weight: bold;">{{ row.rootCause }}</td>
              <td class="status-cell" *ngIf="hasRcaAccess()">
                <!-- Show Validate/Recheck buttons + Submit (after selection) - only if not yet verified -->
                <ng-container *ngIf="!row.VerificationStatus">
                  <div class="status-buttons">
                    <!-- Show loading text instead of Validate button -->
                    <ng-container *ngIf="rcaSubmittingMap[i] && rcaStatusMap[i] === 'Validated'">
                      <span class="loading-text">Validating...</span>
                    </ng-container>
                    <ng-container *ngIf="(!rcaSubmittingMap[i] || rcaStatusMap[i] !== 'Validated') && hasRcaAccess()">
                      <button (click)="setRcaStatus(i, 'Validated')" 
                        [class.selected]="rcaStatusMap[i] === 'Validated'"
                        class="btn-validate">✓ Validate</button>
                    </ng-container>

                    <!-- Show loading text instead of Recheck button -->
                    <ng-container *ngIf="rcaSubmittingMap[i] && rcaStatusMap[i] === 'Need to Recheck'">
                      <span class="loading-text">Rechecking...</span>
                    </ng-container>
                    <ng-container *ngIf="(!rcaSubmittingMap[i] || rcaStatusMap[i] !== 'Need to Recheck') && hasRcaAccess()">
                      <button (click)="setRcaStatus(i, 'Need to Recheck')" 
                        [class.selected]="rcaStatusMap[i] === 'Need to Recheck'"
                        class="btn-recheck">⚠ Need to Recheck</button>
                    </ng-container>

                    <button *ngIf="rcaStatusMap[i] && !rcaSubmittingMap[i] && hasRcaAccess()" 
                      (click)="submitRcaStatus(i, row)" 
                      class="btn-submit">Submit</button>
                  </div>
                </ng-container>
                <!-- Show verified status after verification -->
                <ng-container *ngIf="row.VerificationStatus">
                  <div class="status-verified">
                    <span *ngIf="row.VerificationStatus === 'approved' || row.VerificationStatus === 'Validated' || row.VerificationStatus === 'Validate' || row.VerificationStatus === 'Approve'" class="status-badge validated">✓ Validated</span>
                    <span *ngIf="row.VerificationStatus === 'rejected' || row.VerificationStatus === 'Need to Recheck' || row.VerificationStatus === 'Recheck' || row.VerificationStatus === 'Reject'" class="status-badge recheck">⚠ Rejected</span>
                    <p *ngIf="row.VerifiedBy" class="verified-by">Verified by: {{ row.VerifiedBy }}</p>
                  </div>
                </ng-container>
              </td>
            </tr>
            <tr *ngIf="multiWellCausalAnalysis.length === 0" class="empty-row">
              <td [attr.colspan]="hasRcaAccess() ? 4 : 3">No causal analysis records for selected wells.</td>
            </tr>
          </ng-container>
          <ng-container *ngIf="!isMultiWellMode">
            <tr *ngFor="let row of causalAnalysis; let i = index">
              <td class="table-cell-desc" style="width: 30%;">{{ row.nptEvent }}</td>
              <td class="table-cell-desc">{{ row.rootCause }}</td>
              <td class="status-cell" *ngIf="hasRcaAccess()">
                <!-- Show Validate/Recheck buttons + Submit (after selection) - only if not yet verified -->
                <ng-container *ngIf="!row.VerificationStatus">
                  <div class="status-buttons">
                    <!-- Show loading text instead of Validate button -->
                    <ng-container *ngIf="rcaSubmittingMap[i] && rcaStatusMap[i] === 'Validated'">
                      <span class="loading-text">Validating...</span>
                    </ng-container>
                    <ng-container *ngIf="(!rcaSubmittingMap[i] || rcaStatusMap[i] !== 'Validated') && hasRcaAccess()">
                      <button (click)="setRcaStatus(i, 'Validated')" 
                        [class.selected]="rcaStatusMap[i] === 'Validated'"
                        class="btn-validate">✓ Validate</button>
                    </ng-container>

                    <!-- Show loading text instead of Recheck button -->
                    <ng-container *ngIf="rcaSubmittingMap[i] && rcaStatusMap[i] === 'Need to Recheck'">
                      <span class="loading-text">Rechecking...</span>
                    </ng-container>
                    <ng-container *ngIf="(!rcaSubmittingMap[i] || rcaStatusMap[i] !== 'Need to Recheck') && hasRcaAccess()">
                      <button (click)="setRcaStatus(i, 'Need to Recheck')" 
                        [class.selected]="rcaStatusMap[i] === 'Need to Recheck'"
                        class="btn-recheck">⚠ Need to Recheck</button>
                    </ng-container>

                    <button *ngIf="rcaStatusMap[i] && !rcaSubmittingMap[i] && hasRcaAccess()" 
                      (click)="submitRcaStatus(i, row)" 
                      class="btn-submit">Submit</button>
                  </div>
                </ng-container>
                <!-- Show verified status after verification -->
                <ng-container *ngIf="row.VerificationStatus">
                  <div class="status-verified">
                    <span *ngIf="row.VerificationStatus === 'approved' || row.VerificationStatus === 'Validated' || row.VerificationStatus === 'Validate' || row.VerificationStatus === 'Approve'" class="status-badge validated">✓ Validated</span>
                    <span *ngIf="row.VerificationStatus === 'rejected' || row.VerificationStatus === 'Need to Recheck' || row.VerificationStatus === 'Recheck' || row.VerificationStatus === 'Reject'" class="status-badge recheck">⚠ Rejected</span>
                    <p *ngIf="row.VerifiedBy" class="verified-by">Verified by: {{ row.VerifiedBy }}</p>
                  </div>
                </ng-container>
              </td>
            </tr>
            <tr *ngIf="causalAnalysis.length === 0" class="empty-row">
              <td colspan="3">No causal analysis records.</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Daily Operations Modal (single well) -->
    <div *ngIf="showDailyOps && !isMultiWellMode" class="time-log-modal" (click)="closeDailyOps.emit()">
      <div class="time-log-content" (click)="$event.stopPropagation()">
        <div class="time-log-header">
          <div>
            <p class="time-log-title">Daily Logs</p>
            <p class="time-log-subtitle">{{ isMultiWellMode ? 'Daily reports for selected wells' : 'Daily report for ' + activeWellName }}</p>
          </div>
          <button (click)="closeDailyOps.emit()" class="close-btn">✕</button>
        </div>
        <div class="time-log-body">
          <div *ngIf="dailyOpsLoading" class="time-log-loading">
            <div class="skeleton-row">
              <div class="skeleton-cell"></div>
              <div class="skeleton-cell"></div>
              <div class="skeleton-cell"></div>
            </div>
            <div class="skeleton-row">
              <div class="skeleton-cell"></div>
              <div class="skeleton-cell"></div>
              <div class="skeleton-cell"></div>
            </div>
          </div>
          <div *ngIf="!dailyOpsLoading && dailyOpsError" class="no-data-message">{{ dailyOpsError }}</div>
          <div *ngIf="!dailyOpsLoading && !dailyOpsError && dailyOpsRows.length === 0" class="no-data-message">
            No daily operations entries available.
          </div>
          <table *ngIf="!dailyOpsLoading && !dailyOpsError && dailyOpsRows.length > 0">
            <thead>
              <tr>
                <th *ngIf="isMultiWellMode">Well</th>
                <th>Report Start Date</th>
                <th>Summary</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of dailyOpsRows; let i = index" [class.alt-row]="i % 2 === 1">
                <td *ngIf="isMultiWellMode" class="code-cell">{{ row.wellName }}</td>
                <td>{{ row.reportStartDate }}</td>
                <td>{{ row.summary }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Daily Operations Modal (multi-well: select well first) -->
    <div *ngIf="showDailyOps && isMultiWellMode" class="time-log-modal" (click)="closeDailyOps.emit()">
      <div style="background:#fff;border-radius:12px;box-shadow:0 8px 40px rgba(0,0,0,0.18);min-width:480px;max-width:90vw;display:flex;flex-direction:column;overflow:hidden;"
        (click)="$event.stopPropagation()">
        <div style="display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #f1f5f9;">
          <div>
            <p style="font-size:14px;font-weight:700;color:#1e293b;margin:0">Select Well for Daily Logs</p>
            <p style="font-size:11px;color:#94a3b8;margin:2px 0 0">Choose a well to view its daily reports</p>
          </div>
          <button (click)="closeDailyOps.emit()" style="background:none;border:none;cursor:pointer;color:#94a3b8;font-size:18px;line-height:1;padding:4px">✕</button>
        </div>

        <!-- Well Selector List -->
        <div style="overflow:auto;flex:1;max-height:300px;">
          <div *ngIf="dailyOpsWells.length === 0" style="padding:20px;text-align:center;color:#94a3b8;">
            <p style="font-size:12px;margin:0">No wells with NPT events available</p>
          </div>
          <div *ngFor="let well of dailyOpsWells"
            (click)="selectWellForDailyOps.emit(well.id)"
            style="padding:12px 20px;border-bottom:1px solid #f1f5f9;cursor:pointer;transition:background 0.2s;"
            [style.background]="selectedWellForDailyOps === well.id ? '#eff6ff' : '#fff'">
            <div style="display:flex;align-items:center;gap:12px;">
              <div style="width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;"
                [style.background]="selectedWellForDailyOps === well.id ? '#0066b2' : '#e2e8f0'">
                <span *ngIf="selectedWellForDailyOps === well.id" style="color:#fff;font-size:12px;">✓</span>
              </div>
              <p style="margin:0;font-size:13px;font-weight:600;color:#1e293b;">{{ well.name }}</p>
            </div>
          </div>
        </div>

        <!-- Daily Operations Display Panel -->
        <ng-container *ngIf="selectedWellForDailyOps">
          <div *ngIf="dailyOpsLoading" style="padding:20px;display:flex;flex-direction:column;gap:10px;border-top:1px solid #f1f5f9;">
            <div *ngFor="let _ of [1,2,3]" class="animate-pulse" style="display:grid;grid-template-columns:160px 1fr;gap:12px;padding:8px 16px;">
              <div style="height:12px;background:#e2e8f0;border-radius:4px;"></div>
              <div style="height:12px;background:#e2e8f0;border-radius:4px;"></div>
            </div>
          </div>
          <div *ngIf="!dailyOpsLoading && dailyOpsError" style="padding:16px 20px;border-top:1px solid #f1f5f9;">
            <div style="background:#fee2e2;border:1px solid #fecaca;border-radius:8px;padding:12px;">
              <p style="font-weight:600;color:#991b1b;font-size:13px;margin:0 0 4px">Failed to load daily operations</p>
              <p style="color:#7f1d1d;font-size:12px;margin:0">{{ dailyOpsError }}</p>
            </div>
          </div>
          <div *ngIf="!dailyOpsLoading && !dailyOpsError" style="border-top:1px solid #f1f5f9;max-height:400px;overflow:auto;">
            <div *ngIf="dailyOpsRows.length === 0" style="padding:20px;text-align:center;">
              <p style="color:#94a3b8;font-size:12px;margin:0">No daily operations entries found</p>
            </div>
            <table *ngIf="dailyOpsRows.length > 0" style="width:100%;border-collapse:collapse;font-size:12px;">
              <thead>
                <tr style="background:#f8fafc;position:sticky;top:0;">
                  <th style="padding:10px 16px;text-align:left;font-size:11px;font-weight:600;color:#94a3b8;text-transform:uppercase;letter-spacing:0.05em;white-space:nowrap">Report Start Date</th>
                  <th style="padding:10px 16px;text-align:left;font-size:11px;font-weight:600;color:#94a3b8;text-transform:uppercase;letter-spacing:0.05em">Summary</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of dailyOpsRows; let i = index"
                  style="border-top:1px solid #f1f5f9;"
                  [style.background]="i % 2 === 0 ? '#fff' : '#fafafa'">
                  <td style="padding:9px 16px;font-weight:700;color:#0066b2;white-space:nowrap">{{ row.reportStartDate }}</td>
                  <td style="padding:9px 16px;color:#475569;line-height:1.5">{{ row.summary }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- Time Log Modal -->
    <div *ngIf="showTimeLog" class="time-log-modal" (click)="closeTimeLog.emit()">
      <!-- Single Well Mode -->
      <ng-container *ngIf="!isMultiWellMode">
        <div class="time-log-content" (click)="$event.stopPropagation()">
          <div class="time-log-header">
            <div>
              <p class="time-log-title">Time Log</p>
              <p class="time-log-subtitle">Activity code log for {{ activeWellName }}</p>
            </div>
            <button (click)="closeTimeLog.emit()" class="close-btn">✕</button>
          </div>
          <div class="time-log-body">
            <div *ngIf="loadingTimeLog" class="time-log-loading">
              <div class="skeleton-row">
                <div class="skeleton-cell"></div>
                <div class="skeleton-cell"></div>
                <div class="skeleton-cell"></div>
                <div class="skeleton-cell"></div>
              </div>
              <div class="skeleton-row">
                <div class="skeleton-cell"></div>
                <div class="skeleton-cell"></div>
                <div class="skeleton-cell"></div>
                <div class="skeleton-cell"></div>
              </div>
              <div class="skeleton-row">
                <div class="skeleton-cell"></div>
                <div class="skeleton-cell"></div>
                <div class="skeleton-cell"></div>
                <div class="skeleton-cell"></div>
              </div>
            </div>
            <div *ngIf="!loadingTimeLog && (!activeWellTimeLog || activeWellTimeLog.length === 0)" class="no-data-message">
              No time log records available for this well.
            </div>
            <table *ngIf="!loadingTimeLog && activeWellTimeLog && activeWellTimeLog.length > 0">
              <thead>
                <tr>
                  <th>Activity Code</th>
                  <th>Comment</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let log of activeWellTimeLog; let i = index" [class.alt-row]="i % 2 === 1">
                  <td class="code-cell">{{ log.activityCode }}</td>
                  <td>{{ log.comment }}</td>
                  <td>{{ log.startDate }}</td>
                  <td>{{ log.endDate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
      <!-- Multi-Well Mode: Well Selector + Time Log -->
      <ng-container *ngIf="isMultiWellMode">
        <div style="background:#fff;border-radius:12px;box-shadow:0 8px 40px rgba(0,0,0,0.18);min-width:480px;max-width:90vw;display:flex;flex-direction:column;overflow:hidden;"
          (click)="$event.stopPropagation()">
          <div style="display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #f1f5f9;">
            <div>
              <p style="font-size:14px;font-weight:700;color:#1e293b;margin:0">Select Well for Time Log</p>
              <p style="font-size:11px;color:#94a3b8;margin:2px 0 0">Choose a well to view its activity log</p>
            </div>
            <button (click)="closeTimeLog.emit()" style="background:none;border:none;cursor:pointer;color:#94a3b8;font-size:18px;line-height:1;padding:4px">✕</button>
          </div>
          
          <!-- Well Selector List -->
          <div style="overflow:auto;flex:1;max-height:500px;">
            <div *ngIf="multiWellSelectedNames.length === 0" style="padding:20px;text-align:center;color:#94a3b8;">
              <p style="font-size:12px;margin:0">No wells with NPT events available</p>
              <p style="font-size:11px;color:#cbd5e1;margin:8px 0 0">Time log data is only available for wells that have NPT events.</p>
            </div>
            <div *ngFor="let wellId of multiWellSelectedNames; let i = index" 
              (click)="selectWellForTimeLogHandler(wellId)"
              style="padding:12px 20px;border-bottom:1px solid #f1f5f9;cursor:pointer;transition:background 0.2s;"
              [style.background]="selectedWellForTimeLog === wellId ? '#eff6ff' : '#fff'">
              <div style="display:flex;align-items:center;gap:12px;">
                <div style="width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;"
                  [style.background]="selectedWellForTimeLog === wellId ? '#0066b2' : '#e2e8f0'">
                  <span *ngIf="selectedWellForTimeLog === wellId" style="color:#fff;font-size:12px;">✓</span>
                </div>
                <p style="margin:0;font-size:13px;font-weight:600;color:#1e293b;">{{ wellNameMap?.[wellId] || wellId }}</p>
              </div>
            </div>
          </div>
          
          <!-- Message about removed wells (outside scroll) -->
          <!-- Show message if: total original wells > wells with NPT events -->
          <div *ngIf="(originalSelectedWellsCount && originalSelectedWellsCount > 0) && multiWellSelectedNames && (multiWellSelectedNames.length < originalSelectedWellsCount)" 
            style="padding:12px 20px;background:#fef2f2;border-top:1px solid #fecaca;border-bottom:1px solid #fecaca;">
            <p style="font-size:11px;color:#991b1b;margin:0;font-weight:500;">⚠ Some wells excluded</p>
            <p style="font-size:10px;color:#7f1d1d;margin:4px 0 0">{{ originalSelectedWellsCount - (multiWellSelectedNames?.length || 0) }} well(s) excluded due to no NPT events.</p>
          </div>
         
          <!-- Time Log Display Panel -->
          <ng-container *ngIf="selectedWellForTimeLog">
            <!-- Error State -->
            <div *ngIf="apiTimeLogError && !loadingTimeLog" style="padding:16px 20px;border-top:1px solid #f1f5f9;">
              <div style="background:#fee2e2;border:1px solid #fecaca;border-radius:8px;padding:12px;">
                <p style="font-weight:600;color:#991b1b;font-size:13px;margin:0 0 4px">Failed to load time log</p>
                <p style="color:#7f1d1d;font-size:12px;margin:0 0 8px">{{ apiTimeLogError }}</p>
              </div>
            </div>

            <!-- Loading State -->
            <div *ngIf="loadingTimeLog" style="padding:20px;display:flex;flex-direction:column;gap:10px;border-top:1px solid #f1f5f9;">
              <div *ngFor="let _ of [1,2,3,4,5,6]" class="animate-pulse" style="display:grid;grid-template-columns:120px 1fr 130px 130px;gap:12px;padding:8px 16px;border-bottom:1px solid #f1f5f9;">
                <div style="height:12px;background:#e2e8f0;border-radius:4px;"></div>
                <div style="height:12px;background:#e2e8f0;border-radius:4px;"></div>
                <div style="height:12px;background:#e2e8f0;border-radius:4px;"></div>
                <div style="height:12px;background:#e2e8f0;border-radius:4px;"></div>
              </div>
            </div>

            <!-- Data State -->
            <div *ngIf="!loadingTimeLog && !apiTimeLogError" style="border-top:1px solid #f1f5f9;max-height:400px;overflow:auto;">
              <div *ngIf="!activeWellTimeLog || activeWellTimeLog.length === 0" style="padding:20px;text-align:center;">
                <p style="color:#94a3b8;font-size:12px;margin:0">No time log entries found</p>
              </div>
              <table *ngIf="activeWellTimeLog && activeWellTimeLog.length > 0" style="width:100%;border-collapse:collapse;font-size:12px;">
                <thead>
                  <tr style="background:#f8fafc;position:sticky;top:0;">
                    <th style="padding:10px 16px;text-align:left;font-size:11px;font-weight:600;color:#94a3b8;text-transform:uppercase;letter-spacing:0.05em;white-space:nowrap">Activity Code</th>
                    <th style="padding:10px 16px;text-align:left;font-size:11px;font-weight:600;color:#94a3b8;text-transform:uppercase;letter-spacing:0.05em">Comment</th>
                    <th style="padding:10px 16px;text-align:left;font-size:11px;font-weight:600;color:#94a3b8;text-transform:uppercase;letter-spacing:0.05em;white-space:nowrap">Start Date</th>
                    <th style="padding:10px 16px;text-align:left;font-size:11px;font-weight:600;color:#94a3b8;text-transform:uppercase;letter-spacing:0.05em;white-space:nowrap">End Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let log of activeWellTimeLog; let i = index"
                    style="border-top:1px solid #f1f5f9;"
                    [style.background]="i % 2 === 0 ? '#fff' : '#fafafa'">
                    <td style="padding:9px 16px;font-weight:700;color:#0066b2;white-space:nowrap">{{ log.activityCode }}</td>
                    <td style="padding:9px 16px;color:#475569;line-height:1.5">{{ log.comment }}</td>
                    <td style="padding:9px 16px;color:#64748b;white-space:nowrap">{{ log.startDate }}</td>
                    <td style="padding:9px 16px;color:#64748b;white-space:nowrap">{{ log.endDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </div>
</div>
